export default __webpack_public_path__ + "static/media/arrow-circle-right.7248a254.svg";